import { Select, SelectAsync, Input, Boolean, DateTimePicker } from "./Fields"

export default function Fields({ field, name, value, type, ...props }) {
  name = name || field

  if (type === "select") {
    return <Select name={name} value={value} {...props} />
  }

  if (type === "select-async") {
    return <SelectAsync name={name} value={value} {...props} />
  }

  if (["input", "integer", "number"].includes(type)) {
    return <Input name={name} value={value} type={type} {...props} />
  }

  if (type === "boolean") {
    return <Boolean name={name} value={value} {...props} />
  }

  if (["dateTime", "date"].includes(type)) {
    return <DateTimePicker name={name} value={value} {...props} />
  }

  return null
}
